module.exports = __webpack_public_path__ + "img/box-empty-outside.729295d0.jpg";